import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchLeaseBrandList } from '@/services/site';

/**
 * 获取现场服务的品牌数据
 * - 品牌名称
 */
const useSiteBrandList = () => {
  const { siteBrandList, setSiteBrandList } = useReadyInfo();

  const {
    run: getSiteBrandList,
    data,
    loading,
  } = useRequest(fetchLeaseBrandList, { manual: true });

  useEffect(() => {
    if (!siteBrandList || !siteBrandList?.length) {
      getSiteBrandList().then((res) =>
        setSiteBrandList(
          res?.map((brand) => {
            return {
              label: brand.brand_name,
              value: brand.brand_name,
            };
          }) ?? []
        )
      );
    }
  }, [siteBrandList]);

  return {
    data:
      siteBrandList ||
      (data?.map((brand) => {
        return {
          label: brand.brand_name,
          value: brand.brand_name,
        };
      }) ??
        []),
    loading,
  };
};

export default useSiteBrandList;
